/*
	Fecha y hora para personas: "2026-10-09 14:24:05" (o con T, o "09/10/2026 14:24:05") → "09/10/2026 2:24 pm".
	Esteban: las horas siempre en am/pm, nunca 14:24, y sin segundos. Si no trae hora, solo la fecha; si viene vacío, "".
*/
export const fechaHoraAmPm = (s: string | null | undefined): string => {
	const t = (s || "").replace("T", " ").trim();
	let fecha: string;
	let resto: string;
	const iso = t.match(/^(\d{4})-(\d{2})-(\d{2})(.*)$/);
	const dmy = t.match(/^(\d{2})\/(\d{2})\/(\d{4})(.*)$/);
	if (iso) {
		fecha = iso[3] + "/" + iso[2] + "/" + iso[1];
		resto = iso[4];
	} else if (dmy) {
		fecha = dmy[1] + "/" + dmy[2] + "/" + dmy[3];
		resto = dmy[4];
	} else {
		return t.slice(0, 16);
	}
	const h = resto.match(/^\s+(\d{1,2}):(\d{2})/);
	if (!h) {
		return fecha;
	}
	const hh = Number(h[1]);
	return fecha + " " + (hh % 12 === 0 ? 12 : hh % 12) + ":" + h[2] + " " + (hh < 12 ? "am" : "pm");
};

export default fechaHoraAmPm;

/** Horas de 24 dentro de un texto a am/pm: "Sá 12:00-15:30" → "Sá 12:00 pm – 3:30 pm". Lo demás del texto no se toca. */
export const horasAmPm = (texto: string | null | undefined): string => {
	const h = (hh: string, mm: string) => { const n = Number(hh); return (n % 12 === 0 ? 12 : n % 12) + ":" + mm + " " + (n < 12 ? "am" : "pm"); };
	return String(texto || "")
		.replace(/\b(\d{1,2}):(\d{2})\s*-\s*(\d{1,2}):(\d{2})\b(?!\s*[ap]\.?\s*m)/gi, (_m, a, b, c, d) => h(a, b) + " – " + h(c, d))
		.replace(/\b(\d{1,2}):(\d{2})\b(?!\s*[ap]\.?\s*m)(?!\s*–)/gi, (m, a, b) => (Number(a) <= 23 ? h(a, b) : m));
};

/*
	Nombre de horario para personas: horarioBonito (rango «11:00 am – 3:00 pm») y, si el nombre solo trae la hora de inicio
	(«Lunes 11:00»), esa hora en am/pm. Regla de Esteban para leer una hora suelta sin am/pm: ninguna clase empieza antes de las
	7:00 am, así que «3:00» es 3:00 pm.
*/
export const horarioAmPm = (nombre: string | null | undefined, bonito: (n: string) => string): string => {
	const b = bonito(String(nombre || ""));
	if (/\b[ap]\.?\s*m\b/i.test(b)) return b;
	return b.replace(/\b(\d{1,2}):(\d{2})\b/g, (m, hh, mm) => {
		let n = Number(hh);
		if (n > 23) return m;
		if (n >= 1 && n < 7) n += 12;
		return (n % 12 === 0 ? 12 : n % 12) + ":" + mm + " " + (n < 12 ? "am" : "pm");
	});
};
